import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { getGPUbyId, getGPULog } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextInputField from "../../components/TextInputField";
import LoadingIndicator from "../LoadingIndicator";

const ViewGpuHistory = () => {
  const navigate = useNavigate();
  let param = useParams();
  const gpu_id = param.gpu_id;
  const gridRef = useRef(null);
  const [Sns, setSns] = useState([]);
  const [formData, setFormData] = useState({
    part: "Select Part",
    sku: "",
    lot_no: "",
    order_qty: 0,
    assemble_qty: 0,
    ship_qty: 0,
  });
  const [loadBtn, setLoadBtn] = useState(false);

  const snsGrid = [
    {
      field: "datetime",
      headerText: "DateTime",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "40",
      width: "125",
      textAlign: "center",
    },
    {
      field: "type",
      headerText: "Operation",
      minWidth: "80",
      width: "140",
      textAlign: "left",
    },
    {
      field: "test_result",
      headerText: "Test Res",
      minWidth: "40",
      width: "100",
      textAlign: "left",
    },
    {
      field: "test_value",
      headerText: "Test Value",
      minWidth: "40",
      width: "100",
      textAlign: "left",
    },
    {
      field: "employee",
      headerText: "Operator",
      minWidth: "80",
      width: "100",
      textAlign: "left",
    },
    {
      field: "remarks",
      headerText: "Remarks",
      minWidth: "80",
      width: "100",
      textAlign: "left",
    },
  ];

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  useEffect(() => {
    async function fetchData() {
      if (gpu_id) {
        setLoadBtn(true);
        TimeoutUtility.resetTimeout();
        await getGPUbyId(gpu_id)
          .then((resp) => {
            setFormData({
              part: resp.data.part_number + " - " + resp.data.part_description,
              status: resp.data.status,
              name: resp.data.name,
              gpu_sn: resp.data.gpu_sn,
              test_res: resp.data.test_result,
            });
          })
          .catch((err) => console.log(err.message));
        await getGPULog(gpu_id)
          .then(async (resp) => {
            if (resp?.data?.length > 0) setSns(resp.data || []);
            setLoadBtn(false);
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [gpu_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="GPU HISTORY" />
      {loadBtn ? (
        <LoadingIndicator />
      ) : (
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={8} lg={8} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="GPU Part:"
                  name="part"
                  value={formData.part}
                  placeholder="Part"
                  disabled
                />
                <TextInputField
                  label="GPU Name:"
                  name="name"
                  value={formData.name}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="GPU SN:"
                  name="sku"
                  value={formData.gpu_sn}
                  placeholder="SKU"
                  disabled
                />
              </div>
            </Col>
            <Col xl={4} lg={4} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Last Test Result:"
                  name="test_res"
                  value={formData.test_res}
                  placeholder="Last Test Result"
                  disabled
                />
                <TextInputField
                  label="Status:"
                  name="status"
                  value={formData.status}
                  placeholder="Status"
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <GridComponent
              ref={gridRef}
              className="custom-grid1 pt-8"
              dataSource={Sns}
              height="calc(50vh - 180px)"
              allowResizing
              rowHeight={32}
            >
              <ColumnsDirective>
                {snsGrid.map((item, index) => (
                  <ColumnDirective key={index} {...item} />
                ))}
              </ColumnsDirective>
              <Inject services={[Resize]} />
            </GridComponent>
          </Row>
        </Container>
      )}
      <Row md={"auto"} className="justify-content-center pt-8">
        <Button
          margin="10px"
          padding="20px"
          text="Close"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewGpuHistory;
